// src/components/Eventos/EventsHeats/hooks/usePhotofinish.js
import { useState, useEffect } from 'react';

export const usePhotofinish = (eventDetails, getHeatImages) => {
  const [photofinishModal, setPhotofinishModal] = useState({
    open: false,
    images: [],
    heatNumber: null,
    loading: false
  });
  
  const [heatImagesStatus, setHeatImagesStatus] = useState({});

  // Cargar status de imágenes para todos los heats
  useEffect(() => {
    if (!eventDetails.length || !getHeatImages) return;

    const checkHeatImages = async () => {
      const status = {};
      
      for (const heat of eventDetails) {
        try {
          const images = await getHeatImages(heat.eventNumber, heat.round, heat.heat);
          status[heat.heat] = images.length > 0;
        } catch (error) {
          status[heat.heat] = false;
        }
      }
      
      setHeatImagesStatus(status);
    };

    checkHeatImages();
  }, [eventDetails, getHeatImages]);

  const handlePhotofinishClick = async (e, heatNumber, eventNumber, round) => {
    e.stopPropagation();
    
    setPhotofinishModal({
      open: true,
      images: [],
      heatNumber,
      loading: true
    });

    try {
      const images = await getHeatImages(eventNumber, round, heatNumber);
      setPhotofinishModal(prev => ({
        ...prev,
        images,
        loading: false
      }));
    } catch (error) {
      console.error('Error cargando imágenes de fotofinish:', error);
      setPhotofinishModal(prev => ({
        ...prev,
        images: [],
        loading: false
      }));
    }
  };

  const closePhotofinishModal = () => {
    setPhotofinishModal({
      open: false,
      images: [],
      heatNumber: null,
      loading: false
    });
  };

  return {
    photofinishModal,
    heatImagesStatus,
    handlePhotofinishClick,
    closePhotofinishModal
  };
};